import {Helpers as Base} from "frontend-core";
// @ts-ignore
import hash from "object-hash";


export class Helpers extends Base {
    static isInArray<T>(item: T, array: T[]): boolean {
        let res: boolean;

        if (typeof item !== "object") {
            res = array.includes(item);
        } else {
            res = array.map<string>(i => hash(i)).includes(hash(item));
        }

        return res;
    }

    static hash(val: unknown): string {
        return hash(val);
    }

    static compareHash(val: unknown, hash: string): boolean {
        const newHash: string = this.hash(val);

        return newHash !== hash;
    }
}
